module.exports = __webpack_public_path__ + "img/hion-logo-header-191x67px-01.3e973ec5.jpg";